import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import { useRef } from 'react';
import * as Yup from 'yup';
import { Alert } from '../../../../store';
import type { UntitledEvent} from '../../graphql';
import { useEdit } from '../../graphql';

export interface Props {
  untitledEvent: UntitledEvent;
}

interface Values {
  // operatorNotes: string;
  supportNotes: string;
  permanentNotes: string;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
  error?: Error | undefined;
  alert: Alert;
}

export const useForm = ({ untitledEvent: event }: Props): Form => {
  const [mutation, { loading, error }] = useEdit();

  const alert = Alert.useAlert(error);

  const initialValues = useRef({
    supportNotes: event.location?.user?.support_notes ?? '',
    operatorNotes: event.location?.user?.notes ?? '',
    permanentNotes: event.location?.user?.event_operator_notes ?? ''
  }).current;

  const validationSchema = Yup.object({});

  const formik = useFormik<Values>({
    initialValues,
    validationSchema,
    validateOnMount: true,
    validateOnBlur: true,

    async onSubmit(values: Values) {
      // If not loading, execute the mutation
      if (!loading) {
        await mutation({
          ...values,
          operatorNotes: event.location?.user?.notes,
          id: Number(event.id)
        });
      }
    }
  });

  return {
    formik,
    loading,
    error,
    alert
  };
};
